import { render } from "./viewPhotoWindow.vue?vue&type=template&id=57dcc91a&scoped=true"
import script from "./viewPhotoWindow.vue?vue&type=script&lang=js"
export * from "./viewPhotoWindow.vue?vue&type=script&lang=js"

import "./viewPhotoWindow.vue?vue&type=style&index=0&id=57dcc91a&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57dcc91a"]])

export default __exports__